<template>
	<div class="usercp-primary">
		<el-form ref="form" label-width="90px">
			<el-form-item label="用户名">{{ user.username }}</el-form-item>
			<el-form-item label="头像">
				<el-upload
					class="avatar-uploader"
					:action="uploadAction"
					:show-file-list="false"
					:on-success="handleAvatarSuccess"
					:before-upload="beforeAvatarUpload"
				>
					<img v-if="avatarUrl" :src="avatarUrl" class="avatar" fit="cover" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>
			<el-form-item label="昵称">
				<el-col :span="11">
					<el-input v-model="user.nickname"></el-input>
				</el-col>
			</el-form-item>
			<el-form-item label="邮箱">
				<el-col :span="11">
					<el-input v-model="user.email"></el-input>
				</el-col>
			</el-form-item>
			<el-form-item label="手机">
				<el-col :span="11">
					<el-input v-model="user.mobile"></el-input>
				</el-col>
			</el-form-item>
			<el-divider>个人资料</el-divider>
			<el-form-item label="性别">
				<el-radio v-model="user.gender" label="male">男</el-radio>
				<el-radio v-model="user.gender" label="female">女</el-radio>
			</el-form-item>
			<el-form-item label="出生年月">
				<el-date-picker
					v-model="user.birthday"
					type="month"
					placeholder="选择月"
				>
				</el-date-picker>
			</el-form-item>
			<el-form-item label="体重">
				<el-col :span="6">
					<el-input v-model="user.weight">
						<template slot="append">KG</template>
					</el-input>
				</el-col>
			</el-form-item>
			<el-form-item label="身高">
				<el-col :span="6">
					<el-input v-model="user.height">
						<template slot="append">CM</template>
					</el-input>
				</el-col>
			</el-form-item>
			<el-form-item label="运动喜好">
				<el-checkbox-group v-model="hobbyChecked" :max="5">
					<el-checkbox v-for="v in hobby" :label="v" :key="v">{{
						v
					}}</el-checkbox>
				</el-checkbox-group>
				<el-alert title="最多可选5项" type="info"> </el-alert>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
export default {
	data() {
		return {
			user: undefined,
			avatarUrl: "",
			hobby: [
				"自行车",
				"滑雪",
				"潜水",
				"冲浪",
				"漂流",
				"帆船",
				"攀岩",
				"滑翔伞",
				"跳伞",
				"赛车",
				"摩托车",
				"汽车越野",
				"雪山攀登",
				"滑板",
				"摩托艇",
				"钓鱼",
				"荒野穿越",
				"登山",
				"徒步",
				"马拉松",
				"跑步",
				"健身运动",
				"探洞"
			],
			hobbyChecked: [],
			uploadAction: this.axios.apiGateway + "user/upload_avatar"
		};
	},
	methods: {
		handleAvatarSuccess(res, file) {
			this.avatarUrl = URL.createObjectURL(file.raw);
			this.user.avatar = res.url;
		},
		beforeAvatarUpload(file) {
			return true;
		},
		submit() {
			if (!this.user) {
				return this.util.$emit("login");
			}

			this.user.hobby = this.hobbyChecked;
			this.$message.closeAll();
			this.axios
				.post(this.axios.apiGateway + "user/save_profile", {
					user: this.user
				})
				.then(res => {
					if (res.data.errcode) {
						this.$message.error(res.data.errmsg);
					} else {
						this.count = res.data.num;
						if (res.data.status) {
							this.$notify({
								title: "保存成功",
								message: "资料已更新，请重新登录。",
								type: "success"
							});
						} else {
							this.$message.error("保存失败");
						}
					}
				});
		}
	},
	created() {
		this.user = this.$store.getters.user;
		this.avatarUrl = this.user.avatar;
		this.hobbyChecked = this.user.hobby.split(",");
		this.$store.dispatch("notify", user => {
			this.user = user;
			this.avatarUrl = user.avatar;
			this.hobbyChecked = user.hobby;
		});
	}
};
</script>

<style lang="less">
.usercp-primary .avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	.avatar {
		object-fit: cover;
	}
}
.usercp-primary .avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.usercp-primary .avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.usercp-primary .avatar {
	width: 178px;
	height: 178px;
	display: block;
}
.usercp-primary .avatar-uploader input[type="file"] {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Usercp/Account.vue